import apiClient from './client';
import type { ApiResponse, Vendor } from '../types';

export const vendorsApi = {
  async getProfile(): Promise<Vendor> {
    const res = await apiClient.get<ApiResponse<Vendor>>('/vendor/profile');
    return res.data.data;
  },

  async updateProfile(data: Partial<Vendor>): Promise<Vendor> {
    const res = await apiClient.patch<ApiResponse<Vendor>>('/vendor/profile', data);
    return res.data.data;
  },

  /// Vendor-initiated account deletion (GDPR erasure / Apple 5.1.1(v)).
  ///
  /// Anonymises PII and disables the login; financial records the
  /// marketplace must retain keep their amounts and their vendor_id.
  /// Rejects with 409 `payout_outstanding` while earnings are unpaid.
  async deleteAccount(password: string, reason?: string): Promise<{ deleted: boolean; message: string }> {
    const res = await apiClient.post<ApiResponse<{ deleted: boolean; message: string }>>(
      '/vendor/profile/delete-account',
      { password, ...(reason ? { reason } : {}) }
    );
    return res.data.data;
  },

  async uploadLogo(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await apiClient.post<ApiResponse<{ url: string }>>('/vendor/profile/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data.data;
  },

  async getStripeOnboardingLink(): Promise<{ url: string }> {
    const res = await apiClient.get<ApiResponse<{ url: string }>>('/vendor/stripe/onboarding-link');
    return res.data.data;
  },

  async getStripeDashboardLink(): Promise<{ url: string }> {
    const res = await apiClient.get<ApiResponse<{ url: string }>>('/vendor/stripe/dashboard-link');
    return res.data.data;
  },
};
